/**
 * Loading skeleton for wizard step content.
 * Displays a centered spinner while step content is loading via Suspense.
 */

import { Loader } from '@/components/Loader';
import { STEP_CONTENT_WITH_PAGINATION_HEIGHT_CLASS } from '@/sections/attacks/attackPaths/components/wizards/constants';

export function StepLoadingSkeleton() {
  return (
    <div
      className={`flex ${STEP_CONTENT_WITH_PAGINATION_HEIGHT_CLASS} items-center justify-center`}
    >
      <Loader type="spinner" isLoading />
    </div>
  );
}
